<script setup lang="ts">
const props = defineProps<{
  title: string;
  count: number;
}>();

const expanded = defineModel<boolean>("expanded", {
  required: true,
});
</script>

<template>
  <div
    class="w-12 bg-surface-50 dark:bg-surface-950 rounded-lg shadow-md cursor-pointer hover:bg-surface-hover transition-colors select-none"
    @click="expanded = !expanded"
  >
    <div class="flex flex-col items-center py-4 text-sm text-gray-600 dark:text-gray-300">
      <i :class="['pi mb-2', expanded ? 'pi-chevron-left' : 'pi-chevron-right']"></i>
      <div class="vertical-text text-yellow-500">
        {{ title }} ({{ count }})
      </div>
    </div>
  </div>
</template>

<style scoped>
.vertical-text {
  writing-mode: vertical-rl;
  rotate: 180deg;
  white-space: nowrap;
}
</style>
